import { useContext, createContext, useRef, useState, useEffect } from 'react';

type ScreenContextType = {
  caveatRef: HTMLElement | null;
  setCaveatRef: (ref: HTMLElement | null) => void;
  caveatItemIdsRef: React.RefObject<string[]>;
};
/* istanbul ignore next -- @preserve */
const defaultScreenContext: ScreenContextType = {
  caveatRef: null,
  setCaveatRef: () => {},
  caveatItemIdsRef: { current: [] }
};
export const ScreenContext = createContext(defaultScreenContext);

export const useCaveatRegistry = () => {
  const [caveatRef, setCaveatRef] = useState<HTMLElement | null>(null);
  const caveatItemIdsRef = useRef([]);

  useEffect(() => {
    return () => {
      // cleanup when screen is unmounted
      caveatItemIdsRef.current = [];
      setCaveatRef(null);
    };
  }, []);

  return {
    caveatRef,
    setCaveatRef,
    caveatItemIdsRef
  };
};

export const useScreen = () => {
  return useContext(ScreenContext);
};
